import { Component, Input } from '@angular/core';
import { MembershipServiceService } from '../services/membership.service.service';

import { MembershipService } from '../models/membership.service.model';
import { NotificationService } from '../services/notification.service';
import { LookupService } from '../services/lookup.service';

@Component({
  selector: 'app-membership-service-list',
  templateUrl: './membership-service-list.component.html'
})
export class MembershipServiceListComponent {
  @Input() id: number;

  constructor(public lookupService: LookupService, public service: MembershipServiceService, private notificationService: NotificationService) { }

  ngOnInit() {
    this.service.membershipTypeID = this.id;
    this.lookupService.getServiceTypes();
    this.onSearch();
  }

  model = new MembershipService();
  modelSearch = new MembershipService();
  modelPush = new MembershipService();

  onNew() {
    this.model = new MembershipService();
    $("#PanelSearch, #PanelPush").hide();
    $('#PanelForm').slideToggle();
  }

  onPush() {
    this.modelPush = new MembershipService();
    $("#PanelSearch, #PanelForm").hide();
    $('#PanelPush').slideToggle();
  }

  onEdit(model) {

    $('#PanelForm').slideToggle();

    this.model = Object.assign({}, model);
  }

  onStatus(values: any, membershipServiceID): void {

    if (!confirm('Are you sure?'))
      return;

    this.service.model = new MembershipService();
    this.service.model.membershipServiceID = membershipServiceID;

    if (values.currentTarget.checked)
      this.service.updateStatus(1).subscribe(
        res => {
          this.notificationService.notifySuccess();
        },
        err => { console.log(err); }
      );
    else
      this.service.updateStatus(0).subscribe(
        res => {
          this.notificationService.notifySuccess();
        },
        err => { console.log(err); }
      );
  }

  onArchive(id) {
    if (!confirm('Are you sure?')) {
      return;
    }

    this.service.archive(id).subscribe(
      res => {
        this.notificationService.notifySuccess();
      },
      err => { console.log(err); }
    );

  }

  onSearch() {
    this.service.list = null;
    this.service.currentPage = 1;
    this.service.modelSearch = this.modelSearch;
    this.service.search();
  }

  onSubmitPush() {

    this.service.model = this.modelPush;

    this.service.push().subscribe(
      res => {
        this.notificationService.notifySuccess();
        this.onSearch();
      },
      err => { console.log(err); }
    );
  }
}

